import {inject, Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {environment} from '../../environments/environment';
import {Platform} from '@ionic/angular';
import {StorageService} from '../services/storage.service';

@Injectable({
    providedIn: 'root'
})
export class TutorialGuard  {
    private readonly router: Router = inject(Router);
    private readonly storage: StorageService = inject(StorageService);
    private readonly platform: Platform = inject(Platform);
    constructor() {
    }

    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
            if (this.platform.is('desktop')) {
            this.storage.set('tutorialCompletePromoManiaApp' + environment.storageVersion, true).then(() => {
            });
            return true;
        } else {
            const isComplete = await this.storage.get('tutorialCompletePromoManiaApp' + environment.storageVersion);
            if (!isComplete) {
                await this.router.navigateByUrl('tutorial');
            }
            return isComplete;
        }
    }
}
